export default "__VITE_ASSET__Bru77ub$__"